import React from 'react';
import JBButton from '@jbhi-fi/lanyard-ui/components/Button';
import ArrowDownSvg from '../../../../../assets/svg/icon-arrow-down.svg';
import TermsSvg from '../../../../../assets/svg/icon-terms.svg';
import { RulerIcon } from '@jbhi-fi/lanyard-ui/components/Icons/Ruler';
import { useProductAccordion, goToAccordion } from '../AccordionContext';
import { useIdPrefix } from '@jbhi-fi/components/src/IdPrefix';
import { styles } from './AccordionLinks.css';

type AccordionLinksProps = {
  hasProductOverview: boolean;
  shouldShowDimensions: boolean;
  hasTermsOfService: boolean;
};

const AccordionLinks = ({ hasProductOverview, hasTermsOfService, shouldShowDimensions }: AccordionLinksProps) => {
  const accordion = useProductAccordion();

  const elementIds = {
    wrapper: useIdPrefix('accordion-links'),
    overview: useIdPrefix('prod-ov-anchr'),
    measurements: useIdPrefix('prod-measurements-anchr'),
    terms: useIdPrefix('prod-terms-anchr'),
  };

  if (!hasProductOverview && !hasTermsOfService) return null;

  return (
    <div className={styles.accordionLinksContainer} id={elementIds.wrapper}>
      <div className={styles.accordionLinks}>
        {hasProductOverview ? (
          <div className={styles.accordionLinkItem} id={elementIds.overview}>
            <JBButton
              type="linkWithIcon"
              label="Product overview"
              onClick={() => goToAccordion('product-overview', accordion)}
              icon={<ArrowDownSvg />}
              iconPosition="left"
            />
          </div>
        ) : null}
        {shouldShowDimensions ? (
          <div className={styles.accordionLinkItem} id={elementIds.measurements}>
            <JBButton
              type="linkWithIcon"
              label="Dimensions"
              onClick={() => goToAccordion('dimensions', accordion)}
              icon={<RulerIcon />}
              iconPosition="left"
            />
          </div>
        ) : null}
        {hasTermsOfService ? (
          <div className={styles.accordionLinkItem} id={elementIds.terms}>
            <JBButton
              type="linkWithIcon"
              label="Terms of service"
              onClick={() => goToAccordion('terms-of-service', accordion)}
              icon={<TermsSvg />}
              iconPosition="left"
            />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default AccordionLinks;
